<template>
  <!-- The app's "look here" mark: a red dot on the top right corner of the icon
       in its slot (unread comments). `model-value` shows it, `label` names it for
       a screen reader, and `offset-x` / `offset-y` move it (active filters: out
       onto the button's rim). -->
  <v-badge
    bordered floating dot color="red400"
    :offset-x="DOT_OFFSET_X" :offset-y="DOT_OFFSET_Y"
  >
    <slot />
  </v-badge>
</template>

<script setup>
// Vuetify hangs the dot off the corner of the icon's box. These pull it in onto
// the drawing itself, measured on a `text-h5` (24px) Phosphor icon.
const DOT_OFFSET_X = 5
const DOT_OFFSET_Y = 7
</script>
